import React, { memo } from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-4" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-4">
            Más los <span className="text-[#00C853]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-6">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
          {/* Bono 1 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-8">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-9">01</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
              🎁 BONO 1
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
              CLASE LISTA EN 10 MIN
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">
              10 plantillas de sesión rellenables, checklists pre-clase y
              post-clase y 5 ejemplos completos llenados. Para el profe que no
              tiene tiempo de improvisar.
            </p>
            <div className="flex items-center gap-2" data-id="element-13">
              <span className="text-gray-400 line-through text-sm" data-id="element-14">$8.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-16">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-17">02</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-18">
              🎁 BONO 2
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-19">
              BANCO DE VARIANTES INFINITAS
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-20">
              120 modificaciones de ejercicios en 3 niveles (Fácil/Medio/Pro)
              para adaptar cualquier sesión al grupo real que tenés enfrente en
              30 segundos.
            </p>
            <div className="flex items-center gap-2" data-id="element-21">
              <span className="text-gray-400 line-through text-sm" data-id="element-22">
                $10.000
              </span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-23">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-24">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-25">03</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-26">
              🎁 BONO 3
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-27">
              SIN FILAS, SIN CAOS
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-28">
              12 layouts de estaciones, 20 códigos de voz ProfePack, protocolo
              del disruptivo y plan completo del primer día del año. Para la
              clase que fluye sola.
            </p>
            <div className="flex items-center gap-2" data-id="element-29">
              <span className="text-gray-400 line-through text-sm" data-id="element-30">$9.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-31">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-32">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-33">04</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-34">
              🎁 BONO 4
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-35">
              KIT LLUVIA & ESPACIO CHICO
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-36">
              40 sesiones completas por nivel para cuando no tenés cancha. Nunca
              más cancelar una clase por lluvia.
            </p>
            <div className="flex items-center gap-2" data-id="element-37">
              <span className="text-gray-400 line-through text-sm" data-id="element-38">$9.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-39">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-40">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-41">05</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-42">
              🎁 BONO 5
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-43">
              WHATSAPP PROFE
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-44">
              60 mensajes listos para copiar y pegar para todas las situaciones
              con padres: tiempo de juego, lesiones, conducta en el alambrado,
              post-partido y más.
            </p>
            <div className="flex items-center gap-2" data-id="element-45">
              <span className="text-gray-400 line-through text-sm" data-id="element-46">$8.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-47">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 6 */}
          <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-48">
            <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-49">06</div>
            <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-50">
              🎁 BONO 6
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-51">
              EVALUACIÓN RÁPIDA
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-52">
              12 tests técnicos por nivel, planillas de registro trimestral e
              informe de 1 hoja para entregar a los padres. Evaluás en 15
              minutos y quedás como un DT serio.
            </p>
            <div className="flex items-center gap-2" data-id="element-53">
              <span className="text-gray-400 line-through text-sm" data-id="element-54">$9.000</span>
              <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-55">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        <div className="border border-[#00C853]/40 rounded-2xl p-6 text-center bg-[#000d08]" data-id="element-56">
          <p className="text-[#00C853] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-57">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-58">
            <span className="text-gray-400 line-through text-lg" data-id="element-59">$53.000</span>
            <span className="text-[#00C853] text-2xl font-black tracking-wide" data-id="element-60">
              🎁 GRATIS — Solo con tu MegaPack
            </span>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-61">
            Incluidos en las ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}